import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function fetchById(id, params) {
  const axios = axiosInstance().primoLab;
  let prescriptionTest = [];

  await axios
    .get(`/prescription-tests/${id}`, { params })
    .then(async (response) => {
      prescriptionTest = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { prescriptionTest };
}
